
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/heepsy-alternative",
      function () {
        return require("private-next-pages/heepsy-alternative.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/heepsy-alternative"])
      });
    }
  